import { Platform } from 'react-native';
import DeviceInfo from 'react-native-device-info';
import { version as pkgVersion } from '../../package.json';

export function getAppVersion(): string {
  try {
    if (Platform.OS === 'web') {
      const version: string = pkgVersion;
      return `KDS (${version})`;
    }
    const v = DeviceInfo.getVersion();
    if (!v || v === 'unknown') return 'unknown';
    return `KDS (${v})`;
  } catch {
    return 'unknown';
  }
}
